import React from 'react';
import Group from '../icons/Group';
import IconPublic from '../icons/Public';
import Lock from '../icons/Lock';

const BoardVisibilityIcon = ({ visibility, size = 16, color = 'var(--primary-text-color)', isReadOnly = false }) => {
    const getIcon = () => {
        const tooltipConfig = {
            content: isReadOnly ? `${visibility || 'Private'} (view only)` : (visibility || 'Private'),
            position: 'bottom'
        };

        if (visibility === 'Workspace') {
            return <Group size={size} color={color} tooltip={tooltipConfig} />;
        } else if (visibility === 'Public') {
            return <IconPublic size={size} color={color} tooltip={tooltipConfig} />;
        } else {
            // Private or undefined
            return <Lock size={size} color={color} tooltip={tooltipConfig} />;
        }
    };

    return (
        <div className="board-visibility-badge">
            {getIcon()}
        </div>
    );
};

export default BoardVisibilityIcon;
